export enum CATEGORY {
    MANUAL = 'MANUAL',
    BLUE_PRINT = 'BLUE_PRINT',
}
export interface IApartments {
    id: number
    number: string
    user: {
        name: string
    }
    realEstate: {
        name: string
    }
}
export interface IRequestApartments {
    id: number
    realEstateId: string
    number: string
    userId: string
    filesData: {
        id?: number
        fileId?: number
        name: string
        type: string
        originalName: string
        fileKey: string
        file: File
    }[]
    realEstateApartmentFiles: {
        id?: number
        fileId?: number
        name: string
        type: string
        originalName: string
        fileKey: string
        file: File
    }[]
    createdAt: Date
    updateAt: Date
}

export interface ICreateUpdateApartments {
    realEstateName: string
    number: string
    userName: string
    realApartmentFileName: string
    realApartmentFileCategory: string
}
export interface IRealEstatesName {
    id: number
    name: string
}
export interface IUsersName {
    id: number
    name: string
}
export interface IRequestFile {
    id?: number
    realEstateApartmentId: number
    name: string
    fileKey: string
    mimeType: string
    type: string
}
export interface IFile {
    name: string
    category: string
}
export interface IFileKey {
    fileKey: string
}
